import { useState } from 'react';

export const useSort = (initialOption = 'date-desc') => {
  const [selectedSortOption, setSelectedSortOption] = useState(initialOption);

  return {
    selectedSortOption,
    setSelectedSortOption
  };
};
